import React, { useEffect, useState } from 'react'
import { LangNew } from '../../constant/languange'
import { Spinner9 } from '../../helpers/Spinner'
import { moment } from '../../helpers/Common'

/**
 *
 * @param releaseDate date:'YYYY-MM-DD'
 * @param DefaultBadge component
 * @param variant 'default' | 'simple' | 'text' | 'corner'
 * @returns component
 */
function Badges ({ type = 'link', releaseDate = '', DefaultBadge = null, variant = 'default', active = false, ...props }) {
  const [control, setControl] = useState({ newBadgeExpired: true })
  useEffect(() => {
    setControl({ ...control, newBadgeExpired: releaseDate !== '' ? moment().isSameOrAfter(moment(releaseDate).add(1, 'month'), 'day') : true })
    // eslint-disable-next-line
  }, [])

  if (variant === 'text') {
    const color = active ? '#ffe045' : '#dc3545'
    return (
      <>
        {!control.newBadgeExpired && (
          <span className="ml-1 d-inline-flex align-items-center" style={{ fontSize: '12px', color }}>
            <div className="spinner-grow mx-1" style={{ width: '8px', height: '8px', color }} role="status">
              <span className="sr-only">Loading...</span>
            </div>
            {LangNew}
          </span>
        )}
      </>
    )
  }

  // parent element must be position: relative
  if (variant === 'corner') {
    return (
      <>
        {!control.newBadgeExpired && (
          <span className="position-absolute font-weight-bold" style={{ top: '-9px', right: '-9px', zIndex: 1, background: '#e0245a', color: '#fff', fontSize: '10px', lineHeight: 1, padding: '3px 7px', borderRadius: '999px', pointerEvents: 'none' }}>
            {LangNew}
          </span>
        )}
      </>
    )
  }

  if (variant === 'simple') {
    return (
      <>
        {!control.newBadgeExpired && (
          <span className="badge badge-danger ml-1" style={{ fontSize: '8px', padding: '2px 4px' }}>
            {LangNew}
          </span>
        )}
      </>
    )
  }

  return (
    <>
      {!control.newBadgeExpired
        ? <div style={{ fontSize: '9px' }} className={`badge badge-secondary ${type === 'sub' && 'mr-3'} position-static py-1 d-flex align-items-center mr-1`}>{Spinner9({ size: 9 })} <span className='font-weight-bold' style={{ color: 'inherit' }}>{LangNew.toUpperCase()}</span></div>
        : DefaultBadge}
    </>
  )
}

export default Badges
